import React from 'react';
import { ApolloProvider, HttpLink, InMemoryCache, ApolloClient } from '@apollo/client';
import aws4 from 'aws4';
import { fetchAuthSession, signOut } from 'aws-amplify/auth';
const cache = new InMemoryCache();

let uri = `${import.meta.env.VITE_SECURE_HTTP}://${import.meta.env.VITE_API_HOST}${
	import.meta.env.VITE_API_PREFIX
}/adminv2`;

export const client = new ApolloClient({
	link: new HttpLink({
		uri: uri,
		fetch: awsGraphqlFetch,
	}),
	cache: cache,
});

async function awsGraphqlFetch(uri: any, options: any) {
	options = options || {};
	let signable = {
		service: 'execute-api',
		method: 'POST',
		region: import.meta.env.VITE_AWS_REGION!,
		host: import.meta.env.VITE_API_HOST!,
		path: `${import.meta.env.VITE_API_PREFIX}/adminv2`,
		body: options.body,
	};
	const { credentials } = await fetchAuthSession();
	if (!credentials) {
		signOut();
		throw new Error('No current user');
	}

	aws4.sign(signable, credentials);
	// @ts-expect-error TS(2339): Property 'headers' does not exist on type '{ servi... Remove this comment to see the full error message
	options.headers = signable.headers;
	return fetch(uri, signable);
}

function SimplicityClientWrapper(props: any) {
	return <ApolloProvider client={client}>{props.children}</ApolloProvider>;
}

export default SimplicityClientWrapper;
